import {type RefObject, useLayoutEffect} from 'react';

const NATIVE = typeof CSS !== 'undefined' && CSS.supports('field-sizing', 'content');

// Fallback for browsers without `field-sizing: content`: publishes the text's height as
// --sd-autogrow-height, which the stylesheet applies only when field-sizing is unsupported.
export const useAutoGrow = (ref: RefObject<HTMLTextAreaElement | null>, value: string): void => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: re-measure whenever the text changes.
    useLayoutEffect(() => {
        const field = ref.current;
        if (NATIVE || !field) return;
        field.style.setProperty('--sd-autogrow-height', 'auto');
        field.style.setProperty('--sd-autogrow-height', `${field.scrollHeight}px`);
    }, [ref, value]);
};
